var map = {
	"./0iconmonstr-paintbrush-7.svg": 1883,
	"./1bluePallet.png": 4210,
	"./2redPallet.png": 9263,
	"./3greenPallet.png": 673,
	"./4goldPallet.png": 7232,
	"./5grayPallet.png": 1483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;